import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ApiService } from 'src/app/Service/api.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-kanban-project-wise',
  templateUrl: './kanban-project-wise.component.html',
  styleUrls: ['./kanban-project-wise.component.css'],
  providers: [DatePipe]
})

export class KanbanProjectWiseComponent implements OnInit {
  constructor(private activateRoute: ActivatedRoute, public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe) { }

  projectID: number;

  ngOnInit(): void {
    this.getProjectIDWise();
  }

  isProjectSpinning = false;
  projectData: [];
  title: string;

  getProjectIDWise() {
    this.activateRoute.params.subscribe(params => {
      this.projectID = params.id;
    });

    this.isProjectSpinning = true;

    this._apiService.getAllProjects(0, 0, 'ID', 'desc', ' and ID=' + this.projectID).subscribe(data => {

      this.isProjectSpinning = false;
      this.projectData = data['data'];
      this.title = data['data'][0]['NAME'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }
}
